module.exports = __webpack_public_path__ + "static/eatella-onboarding-demo-6c2392274799e032774f850ebd613ae1.mp4";